import * as React from 'react';
import { styled, Theme, Typography } from '@mineral/core';
import { Link } from 'react-router-dom';
import { User } from '@mineral/icons';
import { colorNeutral100, colorNeutral900 } from '@mineral/tokens';

interface LogoTypeProps {
  title: string;
}

const Root = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  marginRight: theme.spacing(4),
  textDecoration: 'none',
}));

export const LogoType: React.FC<LogoTypeProps> = ({ title }) => (
  <Root
    to="/"
    sx={(theme: Theme) => {
      return {
        height: theme.spacing(5.5),
        paddingRight: theme.spacing(1),
        marginRight: '2px',
      };
    }}>
    <User
      fontSize="large"
      sx={(theme: Theme) => {
        return {
          ml: 1,
          mr: 1,
          color:
            theme.palette.mode === 'light'
              ? theme.accent?.userColor
              : theme.palette.grey[100],
        };
      }}
    />
    <Typography
      variant="h5"
      noWrap
      fontWeight={700}
      color={(theme: Theme) => {
        return {
          color:
            theme.palette.mode === 'light' ? colorNeutral900 : colorNeutral100,
        };
      }}>
      {title}
    </Typography>
  </Root>
);
